import React, { Component } from "react";
import Axios from "axios";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import EditWinner from "./EditWinner";
import "../../css/style.css";

class SubOpenMics extends Component {
  state = {
    subOpenMics: [],
    isLoading: true,
    editWinnerModalOpen: false,
    selectedContest: null,
    notification: { message: "", type: "" },
  };

  componentDidMount() {
    this.fetchSubOpenMics();
  }

  fetchSubOpenMics = async () => {
    this.setState({ isLoading: true });
    try {
      const { match } = this.props;
      const { cId } = match.params;
      let token = getAccessToken();

      const response = await Axios.post(
        Constant.apiBasePath + `openMic/get-all/${cId}`,
        {},
        { headers: { token: token } }
      );
      const { data } = response;
      if (data.status === "Success") {
        this.setState({ subOpenMics: data.data });
      } else {
        console.error("Failed to fetch sub open mics:", data.message);
      }
    } catch (error) {
      console.error("Error fetching sub open mics:", error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  deleteSubOpenMic = async (micId) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        `${Constant.apiBasePath}openMic/deleteSub/${micId}`,
        { headers: { token: token } }
      );
      const { data } = response;
      if (data.status === "Success") {
        // Remove the deleted sub open mic from the state
        this.setState((prevState) => ({
          subOpenMics: prevState.subOpenMics.filter((mic) => mic._id !== micId),
        }));
        // Show success message
        this.showNotification("Sub open mic deleted successfully");
      } else {
        console.error("Failed to delete sub open mic:", data.message);
      }
    } catch (error) {
      console.error("Error deleting sub open mic:", error);
    }
  };

  showNotification = (message, type = "success") => {
    this.setState({ notification: { message, type } });
    setTimeout(() => {
      this.setState({ notification: { message: "", type: "" } });
    }, 3000);
  };

  openEditWinnerModal = (contest) => {
    this.setState({
      editWinnerModalOpen: true,
      selectedContest: contest,
    });
  };

  closeEditWinnerModal = () => {
    this.setState({
      editWinnerModalOpen: false,
      selectedContest: null,
    });
  };

  handleWinnersUpdated = (updatedWinners) => {
    // Update the specific contest in the state with new winners
    this.setState((prevState) => ({
      subOpenMics: prevState.subOpenMics.map((mic) =>
        mic._id === this.state.selectedContest._id
          ? { ...mic, winnersId: updatedWinners }
          : mic
      ),
    }));
  };

  render() {
    const {
      subOpenMics,
      isLoading,
      editWinnerModalOpen,
      selectedContest,
      notification,
    } = this.state;
    const { match } = this.props;
    const { cId } = match.params;

    return (
      <div className="content-page contest-submissions-page contest-management-page open-sessions-page openmic-consistent-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Open Sessions</h4>
                <p className="header-subtitle">
                  Manage open mic sessions, participants, and winners.
                </p>
              </div>
              <Link to={`/add-subcontest/${cId}`}>
                <button
                  type="button"
                  className="btn btn-primary btn-add-event contest-add-match"
                >
                  + Add New Session
                </button>
              </Link>
            </div>
          </div>

          <div className="event-management-body">
            <div className="card contest-submissions-card contest-like-card">
              <div className="card-body">
                <p
                  className="message-feedback"
                  style={{
                    color: notification.type === "error" ? "#dc3545" : "#1e7e34",
                    minHeight: "24px",
                    marginBottom: "12px",
                  }}
                >
                  {notification.message || ""}
                </p>

                <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                  <table className="table event-table contest-submissions-table contest-like-table">
                    <thead>
                      <tr>
                        <th className="open-sessions-sno-col">S.No.</th>
                        <th className="open-sessions-details-col">Session Details</th>
                        <th className="open-sessions-timeline-col">Timeline</th>
                        <th className="open-sessions-status-col">Status</th>
                        <th className="open-sessions-winners-col">Winners</th>
                        <th className="actions-col open-sessions-actions-col">Actions</th>
                        <th className="open-sessions-extra-col">Participants</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan="7" className="table-loading-cell">
                            Loading open sessions...
                          </td>
                        </tr>
                      ) : subOpenMics.length > 0 ? (
                        subOpenMics.map((mic, index) => (
                          <tr key={mic._id} className="table-row">
                            <td className="open-sessions-sno-cell">{index + 1}</td>
                            <td className="open-sessions-details-cell">
                              <div className="open-sessions-name">{mic.name}</div>
                              <div className="open-sessions-about">{mic.about || "-"}</div>
                              <div className="contest-hover-anchor open-sessions-details-anchor">
                                <span className="contest-req-link">View details</span>
                                <div className="contest-hover-card open-sessions-details-popover">
                                  <div className="popover-title">Session Details</div>
                                  <ul>
                                    <li>Name: {mic.name || "-"}</li>
                                    <li>About: {mic.about || "-"}</li>
                                    <li>Start Date: {mic.startDate || "-"}</li>
                                    <li>Closure Date: {mic.closureDate || "-"}</li>
                                    <li>Status: {mic.status === 1 ? "ACTIVE" : "INACTIVE"}</li>
                                  </ul>
                                </div>
                              </div>
                            </td>
                            <td className="contest-timeline-col open-sessions-timeline-col">
                              <div className="timeline-item">
                                <span>START</span>
                                <strong>{mic.startDate || "-"}</strong>
                              </div>
                              <div className="timeline-item">
                                <span>CLOSE</span>
                                <strong className="timeline-close">{mic.closureDate || "-"}</strong>
                              </div>
                            </td>
                            <td className="contest-status-col open-sessions-status-col">
                              <span
                                className={`contest-status-pill ${
                                  mic.status === 1 ? "is-active" : "is-inactive"
                                }`}
                              >
                                {mic.status === 1 ? "ACTIVE" : "INACTIVE"}
                              </span>
                            </td>
                            <td className="contest-winners-col open-sessions-winners-col">
                              <div className="contest-winners-content">
                                {Array.isArray(mic.winnersId) && mic.winnersId.length > 0 ? (
                                  <div className="contest-hover-anchor contest-winners-anchor">
                                    <div className="contest-winners-summary">
                                      <span>
                                        {mic.winnersId[0]}
                                        {mic.winnersId.length > 1
                                          ? ` + ${mic.winnersId.length - 1} more`
                                          : ""}
                                      </span>
                                    </div>
                                    <div className="contest-hover-card contest-winners-popover">
                                      <div className="popover-title">Top Winners:</div>
                                      <ol>
                                        {mic.winnersId.slice(0, 3).map((winner, idx) => (
                                          <li key={`${mic._id}-winner-${idx}`}>{winner}</li>
                                        ))}
                                      </ol>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="contest-no-winners">Winners not announced</div>
                                )}
                                <button
                                  className={`contest-winner-action ${
                                    Array.isArray(mic.winnersId) && mic.winnersId.length > 0
                                      ? "has-result"
                                      : "no-result"
                                  }`}
                                  onClick={() => this.openEditWinnerModal(mic)}
                                >
                                  {Array.isArray(mic.winnersId) && mic.winnersId.length > 0
                                    ? "MANAGE WINNERS"
                                    : "SET WINNERS"}
                                </button>
                              </div>
                            </td>
                            <td className="actions-col open-sessions-actions-col">
                              <button
                                className="contest-icon-btn open-sessions-icon-btn danger"
                                onClick={() => this.deleteSubOpenMic(mic._id)}
                                aria-label="Delete session"
                                type="button"
                              >
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  style={{ fontSize: "13px" }}
                                />
                              </button>
                              <Link
                                to={`/edit-subcontest/${mic._id}`}
                                className="contest-icon-btn open-sessions-icon-btn"
                                aria-label="Edit session"
                              >
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  style={{ fontSize: "13px" }}
                                />
                              </Link>
                            </td>
                            <td className="open-sessions-extra-col">
                              <Link
                                to={`/participants-data/${mic._id}`}
                                className="btn btn-info"
                              >
                                Participants
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="table-loading-cell">
                            No open sessions available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Winner Modal */}
        {selectedContest && (
          <EditWinner
            open={editWinnerModalOpen}
            onClose={this.closeEditWinnerModal}
            contestId={selectedContest._id}
            winners={selectedContest.winnersId || []}
            onWinnersUpdated={this.handleWinnersUpdated}
            showNotification={this.showNotification}
          />
        )}
      </div>
    );
  }
}

export default SubOpenMics;
